import {
	AchievementProgressState,
	type AchievementResponse,
	type ActivatedAchievementResponse
} from '../../domain/Achievement';
import { achievementResponseStore, findAllAchievementResponse } from '../../store/AchievementStore';
import { logger } from '../../logger';

export const activateAchievement = async (achievementId: string): Promise<ActivationResponse> => {
	let state = AchievementProgressState.CREATED;
	let success = false;
	try {
		const response = await fetch(`/up-homeui/gateway/achievement/activate?achievementId=${achievementId}`, {
			method: 'POST'
		});
		if (response.status != 200) {
			await fetch(`/up-homeui/gateway/achievement/activate/metrics`, { method: 'POST' });
			return { state, loading: false, success };
		}
		const activatedAchievementResponse: ActivatedAchievementResponse = await response.json();
		if (activatedAchievementResponse.success) {
			updateAchievementResponseStore(achievementId);
			success = true;
			state = AchievementProgressState.ACTIVATED;
		}
		return { state, loading: false, success };
	} catch (error) {
		logger.error(error);
		return { state, loading: false, success };
	}
};

export type ActivationResponse = {
	state: AchievementProgressState;
	loading: boolean;
	success: boolean;
};

const updateAchievementResponseStore = (achievementId: string) => {
	const achievements = findAllAchievementResponse();
	const updatedActualAchievements = achievements?.actualAchievements.map(achievement => {
		if (achievement.achievementId === achievementId) {
			return {
				...achievement,
				progress: { ...achievement.progress, state: AchievementProgressState.ACTIVATED }
			};
		}
		return achievement;
	});
	const achievementResponse = {
		actualAchievements: updatedActualAchievements,
		pastAchievements: achievements?.pastAchievements,
		comingSoonAchievements: achievements?.comingSoonAchievements,
		batchId: achievements ? achievements.batchId : 0
	} as AchievementResponse;
	achievementResponseStore.set(achievementResponse);
};
